import React, { memo } from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

interface SpCreatedTaskNoticeBannerProps {
  authorName: string;
  onDeclineClick: () => void;
}

export const SpCreatedTaskNoticeBanner = memo(
  ({ authorName, onDeclineClick }: SpCreatedTaskNoticeBannerProps) => {
    return (
      <Flex
        w="full"
        bg="orange.100"
        borderRadius="10px"
        px={4}
        py={3}
        mt="2rem !important"

        alignItems="center"
        justifyContent="center"
        gap={2}
        flexWrap="wrap"
      >
        <Text m="0" fontSize="md">
          <FormattedMessage
            {...messages["serviceRequest.candidates.private.notice"]}
            values={{ authorName: <strong>{authorName}</strong> }}
          />
        </Text>
        <Button
          variant="outline"
          size="sm"
          colorScheme="red"
          onClick={onDeclineClick}
          flexShrink={0}
        >
          <FormattedMessage
            {...messages["serviceRequest.candidates.private.decline"]}
          />
        </Button>
      </Flex>
    );
  }
);

SpCreatedTaskNoticeBanner.displayName = "SpCreatedTaskNoticeBanner";
